import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';
import { withIntegrationApp } from 'src/hocs/withIntegrationApp';
import { WizardProvider, useWizard } from '../components/wizard/WizardContext';
import { CampaignProvider } from '../contexts/CampaignContext';
import BuildYourOutreachFlow from './BuildYourOutreachFlow';
import ConfigureSettings from './ConfigureSettings';
import type { CampaignInit } from './campaignWizard.types';

const WizardSteps = () => {
  const { currentStep } = useWizard();

  if (currentStep === 2) return <ConfigureSettings />;
  return <BuildYourOutreachFlow />;
};

const CampaignWizardLayout = () => {
  const location = useLocation();
  const state =
    (location.state as { campaignInit?: CampaignInit } | null) || null;
  const campaignInit = state?.campaignInit;

  return (
    <CampaignProvider>
      <WizardProvider
        getNewCampaignDefaults={(base) => {
          return {
            ...base,
            ...(campaignInit ? campaignInit : {}),
            referenceId: campaignInit?.referenceId ?? `${uuidv4()}`,
            schedule: undefined, // new campaigns require a contact window
          };
        }}
      >
        <WizardSteps />
      </WizardProvider>
    </CampaignProvider>
  );
};

export default withIntegrationApp(CampaignWizardLayout);
